export default __webpack_public_path__ + "static/media/roma.44fe3d85.png";